import { jsx as _jsx } from "react/jsx-runtime";
export const PrintTemplateCss = () => (_jsx("style", { children: `
      @media print {
        html {
          margin: 0;
          padding: 0;
          overflow: hidden;
        }
      
        body {
          width: 1024px;
          margin: 0;
          padding: 0;
          overflow: hidden;
        }
        
        header, footer {
          display: none;
        }
        
        .Main {
          display: flex;
          flex-wrap: wrap;
          width: 1024px !important;
          min-width: 1024px;
          padding-top: 1rem;
          gap: 1.5rem;
        }
        
        .FarbweltBannerDesktop {
          display: none;
        }
        
        .FarbweltBannerMobile {
          display: none;
        }
        
        .Gallery {
          flex: 0 0 83.33%; /* 10 / 12 * 100% = 83.33% */
          
          .DesktopPreview {
            display: none;
          }
          
          .MobilePreview {
            display: none;
          }
          
          .PrintPreview {
            display: block;
            
            .FarbweltBannerDesktop {
              display: flex !important;
            }
          }
        }
        
        .MainColumn {
          flex: 1 !important;
          width: 100% !important;
        }
        
        .ContactCardColumn {
          display: none;
        }
        
        .DescriptionTexts {
          display: block !important;
          overflow: visible !important;
          -webkit-line-clamp: initial !important;
          -webkit-box-orient: unset !important;
          -webkit-text-fill-color: initial !important;
          background: white !important;
          height:auto !important;
          max-height: none !important;
        }
        
        .ContactCard {
          position: relative;
        }
        
        .ClassifiedKeys {
            > button {
              display: none;
            }
        }
        
        .FeaturesPreview {
          display: flex;
          flex-wrap: wrap;
        }
        
        .FeaturesPreview > * {
          flex: 1 1 40%;
        }
        
         #ad-leaderboard-fallback, #ad-leaderboard {
          display: none;
        }
        
        .Section {
          page-break-inside: avoid;
          break-inside: avoid;
          display: contents;
          -webkit-print-color-adjust:exact;
          color-adjust: exact;
        }
        
        .HideOnPrint {
          display: none;
        }

        [class*="adjust-sb_banner"] {
            display: none;
        }
      }
    ` }));
